/**
 * Custom scripts for child theme.
 */

// Déclarations des variables utiles
const mobileQuery = window.matchMedia('(max-width: 991px)');
const desktopQuery = window.matchMedia('(min-width: 992px)');
const myCollapsible = document.getElementById('navbarNavDropdown');

// #DEBUT - Gestion du menu sticky
function fixmenu() {
	const scroll = window.scrollY;
	const mainNav = document.getElementById("navbarNavDropdown");
	const banner = document.getElementById("banner");
	if (scroll >= 122) {
		banner.classList.add("have-sticky");
		mainNav.classList.add("is-sticky");
	} else {
		banner.classList.remove("have-sticky");
		mainNav.classList.remove("is-sticky");
	}
}
// Limitation avec throttling (ex: 1 appel toutes les 200ms)
window.addEventListener('scroll', throttle(fixmenu, 200));
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function() {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function() {
        if ((Date.now() - lastRan) >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}
// En cas d'écran avec un léger scroll mais menu pas encore sticky : retour en haut de page à l'ouverture du menu mobile pour faire plus soigné
myCollapsible.addEventListener('show.bs.collapse', event => {
	if (window.scrollY <= 110) {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
})
// #FIN gestion du menu sticky

// #DEBUT - Lightbox membres de l'équipe (compatible pagination AJAX)
document.addEventListener('show.bs.modal', function (e) {
    const modal = e.target;
    const img = modal.querySelector('img');
    if (img && e.relatedTarget && e.relatedTarget.dataset.full) {
        img.src = e.relatedTarget.dataset.full;
        img.alt = e.relatedTarget.dataset.caption || '';
    }
});
// #FIN

// Document ready
document.addEventListener("DOMContentLoaded", function() {



	// #DEBUT menu principal - Gestion des menus de 3ème niveau
    document.querySelectorAll(".navbar-nav button").forEach(link => {

        link.addEventListener("click", function (e) {
            let submenu = this.nextElementSibling;
            if (submenu) {

                // Ferme tous les autres sous-menus de 3ème niveau
                document.querySelectorAll(".dropdown-menu .show").forEach(openMenu => {
                    if (openMenu !== submenu) {
                        openMenu.classList.remove("show");

                        // Récupérer le bouton parent du sous-menu ouvert
                        const parentLi = openMenu.closest('li');
                        const parentButton = parentLi.querySelector('[aria-expanded]');

                        // Mettre à jour aria-expanded et la classe "show" du bouton parent
                        if (parentButton) {
                            parentButton.setAttribute('aria-expanded', 'false');
                            parentButton.classList.remove("show");
                        }
                    }
                });

                // Crée un bouton "retour" au clic du sous-menu
                // Ajout du bouton sauf si on est dans un sous-menu en gras en format écran
                if (!(mobileQuery.matches === false)) {

                    if (!submenu.querySelector(".btn-back")) {

                        let backButtonLi = document.createElement("li");
                        let backButton = document.createElement("button");
						backButtonLi.className = "menu-item";
                        backButton.className = "btn-back btn ic ic-chevron-left";
                        backButton.appendChild(document.createTextNode("Retour")); // Ajoute le mot "Retour"

                        // Ajoute le bouton juste avant le sous-menu (dans le <li> parent)
                        backButtonLi.appendChild(backButton);
                        submenu.prepend(backButtonLi);

                        backButton.addEventListener("click", function () {
                            submenu.classList.remove("show");

                            // Récupérer et mettre à jour aria-expanded du bouton parent
                            const parentButton = submenu.closest('li').querySelector('[aria-expanded]');
                            if (parentButton) {
                                parentButton.setAttribute('aria-expanded', 'false');
                                parentButton.classList.remove("show");
                            }

                        });

                    }

                }
            }
        });
    });

    // Empêche le menu de se refermer au clic
    document.querySelectorAll('.dropdown-menu').forEach(function(menu) {
        menu.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        // Gère l'événement keydown pour le menu
        menu.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                // Cache le menu
                menu.classList.remove('show');

                // Met le focus sur le lien adjacent
                const siblingLink = menu.previousElementSibling;
                if (siblingLink && siblingLink.tagName === 'A') {
                    siblingLink.focus();
                }
            }
        });
    })
    // #FIN menu principal

	// Prise du focus au clic de la recherche
    if(document.getElementById("search-form--collapse")) {
        document.getElementById('search-form--collapse').addEventListener('shown.bs.collapse', function() {
            document.getElementById('s-1').focus();
        });
    }

	// -- DEBUT -- Affichage du bouton de retour en haut de page
	var btnTop = document.getElementById('btn-to-top');

    if(btnTop) {
        window.addEventListener('scroll', function() {
            // Vérifier si la position de défilement vertical est supérieure à 300 pixels
            if (window.scrollY > 300) {
                // Ajouter la classe 'show' au bouton
                btnTop.classList.add('show');
            } else {
                // Retirer la classe 'show' du bouton
                btnTop.classList.remove('show');
            }
        });
    }
    // -- FIN -- Affichage du bouton de retour en haut de page

	// -- DEBUT -- Mémorisation de la fermeture de la zone d'alerte générale
    const alertId = "global-alert";
    const alertElement = document.getElementById(alertId);

    if (alertElement) {

        if (sessionStorage.getItem(alertId + "-dismissed") === "true") {
            // Ne rien faire, l'alerte reste masquée (d-none déjà présente)
        } else {
            // Affiche l'alerte en retirant la classe d-none
            alertElement.classList.remove("d-none");

            alertElement.addEventListener("closed.bs.alert", function () {
                sessionStorage.setItem(alertId + "-dismissed", "true");
            });
        }

    }
    // -- FIN -- Mémorisation de la fermeture de la zone d'alerte générale

});

// Fonction pour remplacer les <button> par des <h3> en desktop
function replaceButtonsWithHeadings() {
    if (desktopQuery.matches) { // Si on est en desktop
        // Sélectionner tous les boutons dans les éléments .menu-item-has-children
        const buttons = document.querySelectorAll('.navbar-nav .menu-item-has-children .menu-item-has-children > button[aria-expanded]');

        buttons.forEach(button => {
            // 1. Créer un élément <h3>
            const heading = document.createElement('h3');

            // 2. Copier le contenu du bouton vers le <h3>
            heading.innerHTML = button.innerHTML;

            // 3. Copier les attributs nécessaires (sauf aria-expanded et les événements)
            // Exemple : copier la classe, l'id, etc.
            if (button.className) {
                heading.className = button.className;
            }
			heading.setAttribute('tabindex', '0');

            // 4. Remplacer le bouton par le <h3>
            button.parentNode.replaceChild(heading, button);
        });
    }
}

// Exécuter au chargement de la page
 // document.addEventListener('DOMContentLoaded', replaceButtonsWithHeadings);



/**
 * Disclosure Navigation – touches fléchées (optionnelles)
 * Spec : https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/examples/disclosure-navigation/
 *
 * Comportement des flèches (en complément du Tab natif qui reste intact) :
 *
 * Focus sur un bouton L1 (bouton .nav-link) :
 *   ↓ ou → : dropdown fermé → bouton L1 suivant
 *              dropdown ouvert → premier lien du dropdown
 *   ↑ ou ← : bouton L1 précédent
 *   Home      : premier bouton L1
 *   End       : dernier bouton L1
 *
 * Focus sur un item dans un dropdown ouvert (L2 : bouton ou lien) :
 *   ↓ ou → : item suivant dans le dropdown
 *   ↑ ou ← : item précédent dans le dropdown
 *   Home      : premier item du dropdown
 *   End       : dernier item du dropdown
 *   Échap     : ferme le dropdown, focus sur le bouton L1 qui le contrôle
 *
 * Focus sur un lien dans un submenu (L3) :
 *   ↓ ou → : lien suivant dans le submenu
 *   ↑ ou ← : lien précédent dans le submenu
 *   Home      : premier lien du submenu
 *   End       : dernier lien du submenu
 *   Échap     : ferme le submenu, focus sur le bouton L2 qui le contrôle
 *
 * Fermeture automatique :
 *   - Échap depuis n'importe quel niveau remonte d'un niveau
 *   - Focus hors du nav ferme tous les dropdowns ouverts
 */

(function () {
  'use strict';

  const NAV = document.querySelector('nav');   // ou '#main-menu' si pas de <nav>

  if (!NAV) return;

  // ─── Helpers ────────────────────────────────────────────────────────────────

  /** Tous les boutons L1 (.nav-link avec dropdown) */
  function getL1Buttons() {
    return Array.from(NAV.querySelectorAll(':scope ul#main-menu > li > button.nav-link'));
  }

  /**
   * Items focusables visibles dans un dropdown ouvert.
   * On récupère les enfants directs (boutons L2 + liens L2), en excluant
   * les liens cachés à l'intérieur d'un submenu fermé.
   */
  function getDropdownItems(dropdownMenu) {
    return Array.from(
      dropdownMenu.querySelectorAll(':scope > li > button.dropdown-item, :scope > li > a.dropdown-item, :scope > li > h3.dropdown-item')
    );
  }

  /** Items focusables d'un submenu L3 */
  function getSubmenuItems(submenu) {
    return Array.from(submenu.querySelectorAll(':scope > li > a.dropdown-item'));
  }

  /** Ouvre un dropdown Bootstrap et met à jour aria-expanded */
  function openDropdown(btn) {
    bootstrap.Dropdown.getOrCreateInstance(btn).show();
  }

  /** Ferme un dropdown Bootstrap */
  function closeDropdown(btn) {
    const instance = bootstrap.Dropdown.getInstance(btn);
    if (instance) instance.hide();
  }

  /** Ferme tous les dropdowns L1 ouverts */
  function closeAllL1() {
    getL1Buttons().forEach(closeDropdown);
  }

  /**
   * Déplace le focus dans un tableau d'items.
   * Pas de wrapping : on s'arrête aux bornes (conforme APG sans wrapping).
   */
  function moveFocus(items, current, delta) {
    const idx = items.indexOf(current);
    const next = idx + delta;
    if (next >= 0 && next < items.length) {
      items[next].focus();
    }
  }

  // ─── Gestionnaire de touches ─────────────────────────────────────────────────

  NAV.addEventListener('keydown', function (e) {
    const target = e.target;
    const key    = e.key;

    if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End', 'Escape'].includes(key)) {
      return;
    }

    const l1Buttons = getL1Buttons();

    // ── Cas 1 : focus sur un bouton L1 ──────────────────────────────────────
    if (l1Buttons.includes(target)) {
      const isExpanded = target.getAttribute('aria-expanded') === 'true';

      switch (key) {
        case 'ArrowDown':
        case 'ArrowRight':
          e.preventDefault();
          if (isExpanded) {
            // Entre dans le dropdown : focus sur le premier item
            const menu  = target.nextElementSibling;
            const items = getDropdownItems(menu);
            if (items.length) items[0].focus();
          } else {
            // Avance vers le bouton L1 suivant
            moveFocus(l1Buttons, target, +1);
          }
          break;

        case 'ArrowUp':
        case 'ArrowLeft':
          e.preventDefault();
          moveFocus(l1Buttons, target, -1);
          break;

        case 'Home':
          e.preventDefault();
          l1Buttons[0].focus();
          break;

        case 'End':
          e.preventDefault();
          l1Buttons[l1Buttons.length - 1].focus();
          break;

        case 'Escape':
          e.preventDefault();
          closeDropdown(target);
          break;
      }
      return;
    }

    // ── Cas 2 : focus sur un item dans un submenu L3 ─────────────────────────
    const parentSubmenu = target.closest('ul.submenu');
    if (parentSubmenu) {
      const items = getSubmenuItems(parentSubmenu);

      switch (key) {
        case 'ArrowDown':
        case 'ArrowRight':
          e.preventDefault();
          moveFocus(items, target, +1);
          break;

        case 'ArrowUp':
        case 'ArrowLeft':
          e.preventDefault();
          moveFocus(items, target, -1);
          break;

        case 'Home':
          e.preventDefault();
          items[0].focus();
          break;

        case 'End':
          e.preventDefault();
          items[items.length - 1].focus();
          break;

        case 'Escape': {
          e.preventDefault();
          // Remonte au bouton L2 (déclencheur du submenu)
          const l2Btn = parentSubmenu.previousElementSibling;
          if (l2Btn) {
            closeDropdown(l2Btn);
            l2Btn.focus();
          }
          break;
        }
      }
      return;
    }

    // ── Cas 3 : focus sur un item dans un megamenu L2 (bouton ou lien) ───────
    const parentMegamenu = target.closest('ul.megamenu');
    if (parentMegamenu) {
      const items = getDropdownItems(parentMegamenu);

      switch (key) {
        case 'ArrowDown':
        case 'ArrowRight':
          e.preventDefault();
          moveFocus(items, target, +1);
          break;

        case 'ArrowUp':
        case 'ArrowLeft':
          e.preventDefault();
          moveFocus(items, target, -1);
          break;

        case 'Home':
          e.preventDefault();
          items[0].focus();
          break;

        case 'End':
          e.preventDefault();
          items[items.length - 1].focus();
          break;

        case 'Escape': {
          e.preventDefault();
          // Remonte au bouton L1 qui a ouvert ce megamenu
          const l1Btn = parentMegamenu.previousElementSibling;
          if (l1Btn) {
            closeDropdown(l1Btn);
            l1Btn.focus();
          }
          break;
        }
      }
    }
  });

  // ─── Fermeture quand le focus quitte le nav ───────────────────────────────

  NAV.addEventListener('focusout', function (e) {
    // relatedTarget = élément qui reçoit le focus ensuite
    if (!NAV.contains(e.relatedTarget)) {
      closeAllL1();
    }
  });

})();

